import React, { Component } from 'react';
import { Button, Image } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { userActions as actions } from '../actions';
import TextInputBox from './TextInputBox';
import '../content/css/NotAllowedPage.css';
import AuthService from "../services/auth.service";
import { userConstants as constants } from "../constants";

const logo = require("../content/images/legly_logo_color.svg");

export const loginStatus = {
    DEFAULT: "DEFAULT",
    NO_CONNECTION: "NO_CONNECTION",
    MULTIPLE_CONNECTIONS: "MULTIPLE_CONNECTIONS"
}

class ExternalSSOLogin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            status: loginStatus.DEFAULT
        };

        this.authService = new AuthService();
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.connectionNames !== prevProps.connectionNames) {
            if (!this.props.connectionNames || this.props.connectionNames.length === 0) {
                this.setState({ status: loginStatus.NO_CONNECTION })
            } else if (this.props.connectionNames.length === 1) {
                // auto-redirect to auth0 with the connection name
                this.authService.login(this.props.connectionNames[0]);
            } else {
                // list all alternatives 
            }
        }
    }

    handleEmailChange(email) {
        this.setState({ email });
    }

    handleConfirmClick() {
        if (this.state.email === '') return;

        this.props.getConnectionsForDomain(this.state.email);
    }

    render() {
        return (
            <div className="center-horizontally">
                <div>
                    <Image className="logo" src={logo} />
                    <h3>Log in with your single sign-on credentials</h3>

                    {this.state.status == loginStatus.NO_CONNECTION &&
                        <span>
                            There was a problem logging in with SSO
                            SSO may not be available or configured for this account.
                            To learn more about the requirements for using SSO in Legly, visit our Knowledge Base. Learn more.
                        </span>
                    }

                    <TextInputBox
                        helpText="Enter your email."
                        onChange={this.handleEmailChange}
                    />
                    <Button variant="secondary" onClick={this.handleConfirmClick}>Log in</Button>
                    {this.props.connectionNames == constants.LINK_EMAIL_OTHER_LOGIN_CONNECTION_EXISTS &&
                        <ul>
                            {this.getConnectionAlternatives()}
                        </ul>
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    state => state.authentication,
    dispatch => bindActionCreators(actions, dispatch)
)(ExternalSSOLogin);



// WEBPACK FOOTER //
// ./src/components/ExternalSSOLogin.js